export default __webpack_public_path__ + "static/media/b42.0cf171ca.png";